import { render, staticRenderFns } from "./ProgressDiagram.vue?vue&type=template&id=52244e39&scoped=true"
import script from "./ProgressDiagram.vue?vue&type=script&lang=js"
export * from "./ProgressDiagram.vue?vue&type=script&lang=js"
import style0 from "./ProgressDiagram.vue?vue&type=style&index=0&id=52244e39&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52244e39",
  null
  
)

export default component.exports